export class Delegation {
  'Delegated From AuthUser Id': string;
  'Delegated To AuthUser Id': string;
  'Start Date': string;
  'End Date': string;
  'Reason': string;
  'Created By AuthUser Id': string;
  status: string;
  id: string;
  approvalId: string;
  'Load default Role Assignments': boolean;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/delegation.ts